const topics = [
  'как объявлять изменения, чтобы сообщение дошло до каждого;',
  'как объяснять причины, а не только сообщать сам факт;',
  'как отвечать на неудобные вопросы, не уходя от ответа;',
  'как говорить о неприятных последствиях честно и прямо;',
  'как не создавать ложных ожиданий у команды;',
  'как работать с эмоциональной реакцией сотрудников;',
  'как вовлекать руководителей среднего звена в донесение информации;',
  'как поддерживать единый информационный контекст во всей компании.',
];

export default function CommunicationSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Управление изменениями и коммуникация
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как говорить с командой о сложных изменениях, чтобы снизить неопределённость и сопротивление
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {topics.map((t, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-chat-3-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{t}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Чем меньше информации сотрудники получают от руководства, тем больше информации они создают самостоятельно.
          </p>
          <p className="text-sm text-gray-400 mt-3">
            Это практический управленческий принцип: неопределённость заполняется домыслами, если её не заполнить честной коммуникацией.
          </p>
        </div>
      </div>
    </section>
  );
}